export default __webpack_public_path__ + "static/PAPC-711-29672f0f1d7be1811e94d1b42e8ad573.jpg";